// TheAdvance cross-web-version session sync — originally pinged t.me/telegram.me/_websync_ (loaded
// as <script>) to share auth/redirect state across the TheAdvance web clients. The Advance Chat runs purely on
// its own backend, so there is nothing to sync; these are inert no-ops kept only to satisfy the
// existing call sites. The call sites can be removed in a later cleanup pass.

const WEBSYNC_KEY = 'tgme_sync';

export const forceWebsync = (_authed: boolean) => Promise.resolve();

export function stopWebsync() {}

export function startWebsync() {}

export function clearWebsync() {
  localStorage.removeItem(WEBSYNC_KEY);
}
